import { useTranslation } from 'react-i18next'
import { H2, H3, Button } from '@/components/atoms'
import {
  CoverageStarsIcon,
  CoveragePolicyFolderIcon,
  CoveragePriceIcon,
} from '@/components/atoms/icons/coverage-feature'
import { FeatureItem } from '@/components/molecules'

const FEATURES = [
  { key: 'managePolicy', Icon: CoveragePriceIcon },
  { key: 'exclusiveBenefits', Icon: CoverageStarsIcon },
  { key: 'easyClaims', Icon: CoveragePolicyFolderIcon },
] as const

export function PetStepSixPage({
  onBack,
  onContinue,
  isLoading = false,
}: {
  onBack: () => void
  onContinue: () => void
  isLoading?: boolean
}) {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto pb-4 md:flex md:flex-row md:justify-between md:pb-0">
        <div className="flex flex-col justify-between gap-4 md:max-w-96 md:pt-6">
          <div className="flex flex-col gap-4 md:gap-6">
            <H2 className="hidden md:block">
              {t('onboarding.pet.step6.title')}
            </H2>
            <H3 className="md:hidden">{t('onboarding.pet.step6.title')}</H3>
          </div>
          <div className="hidden gap-3 md:mb-2.5 md:flex">
            <Button
              className="h-12"
              variant="secondary"
              onClick={onBack}
              disabled={isLoading}
              data-testid="step-six-back"
            >
              {t('onboarding.pet.back')}
            </Button>
            <Button
              className="h-12"
              onClick={onContinue}
              loading={isLoading}
              data-testid="step-six-finish"
            >
              {t('onboarding.pet.continue')}
            </Button>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-8 md:mt-0 md:max-w-89.5">
          {FEATURES.map(({ key, Icon }) => (
            <FeatureItem
              key={key}
              icon={<Icon />}
              title={t(`onboarding.pet.step6.features.${key}.title`)}
              description={t(
                `onboarding.pet.step6.features.${key}.description`,
              )}
            />
          ))}
        </div>
      </div>

      <div className="flex w-full gap-3 pt-4 md:hidden">
        <Button
          className="h-12 w-full"
          variant="secondary"
          onClick={onBack}
          disabled={isLoading}
          data-testid="step-six-back"
        >
          {t('onboarding.pet.back')}
        </Button>
        <Button
          className="h-12 w-full"
          onClick={onContinue}
          loading={isLoading}
          data-testid="step-six-finish"
        >
          {t('onboarding.pet.continue')}
        </Button>
      </div>
    </div>
  )
}
